import advancedSettings from './AdvancedSettings.json';
import allTags from './AllTags.json';
import boltIsoParameters from './BoltIsoParameters.json';
import bomParameters from './BomParameters.json';
import isoParameters from './IsoParameters.json';
import referenceDimensionIsoParameters from './ReferenceDimensionIsoParameters.json';
import referenceDimensionObjectTypeIsoParameters from './ReferenceDimensionObjectTypeIsoParameters.json';
import validationMap from './ValidationMap.json';

export const DEFAULT_PIPEEX_PROFILE_NAME = 'Default';

export type DefaultPipeexProfileSections = {
  advancedSettings: string;
  allTags: string;
  bomParameters: string;
  isoParameters: string;
  validationMap: string;
};

function stringifyProfileSection(section: unknown): string {
  return JSON.stringify(section);
}

export function getDefaultPipeexProfileSections(): DefaultPipeexProfileSections {
  return {
    advancedSettings: stringifyProfileSection(advancedSettings),
    allTags: stringifyProfileSection(allTags),
    bomParameters: stringifyProfileSection(bomParameters),
    isoParameters: stringifyProfileSection([
      ...isoParameters,
      ...boltIsoParameters,
      ...referenceDimensionIsoParameters,
      ...referenceDimensionObjectTypeIsoParameters,
    ]),
    validationMap: stringifyProfileSection(validationMap),
  };
}
